import React, { useState, useEffect } from 'react';
import apiService from '../utils/api';
import Sidebar from './sidebar/Sidebar';
import Snackbar from '@mui/material/Snackbar';
import './Role.css';
import { CustomSelect } from '../components/modals/CreateBlankModal'; 
import Loader from './Loader';
import Delete from '@mui/icons-material/Delete';
import Breadcrumbs from './Breadcrumbs'; 
import { useSearchParams } from 'react-router-dom';
import UserRoleAssignedTemplate from "../components/rbac/UserRoleAssignedTemplate";

const Roles = () => {
  const [roles, setRoles] = useState([]);
  const [filteredRoles, setFilteredRoles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newRoleName, setNewRoleName] = useState('');
  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
const [userId, setUserId] = useState('');
const [selectedRole, setSelectedRole] = useState('');
const [availableRoles, setAvailableRoles] = useState([]);
const [snackbarOpen, setSnackbarOpen] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState('');
const [isSuccess, setIsSuccess] = useState(false);
const [isEditModalOpen, setIsEditModalOpen] = useState(false);
const [editingId, setEditingId] = useState(null);
const [editRoleName, setEditRoleName] = useState('');
const [editRoleDescription, setEditRoleDescription] = useState('');
const [showUserDetails, setShowUserDetails] = useState(false);
const [userDetails, setUserDetails] = useState([]);
const [rowsPerPage, setRowsPerPage] = useState(10);
const [currentPage, setCurrentPage] = useState(1);
const [newRoleDescription, setNewRoleDescription] = useState('');
const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
const [deleteRoleId, setDeleteRoleId] = useState(null);
const [allUsers, setAllUsers] = useState([]);
const [selectedUserId, setSelectedUserId] = useState('');
const [userDetailsSearch, setUserDetailsSearch] = useState('');
const [filteredUserDetails, setFilteredUserDetails] = useState([]);
const [searchParams] = useSearchParams();


const fetchRoles = async () => {
  try {
    setIsLoading(true);
    const response = await apiService.fetchData('metadata/role');
    console.log('API Response for Roles:', response);
    const rolesWithDescriptions = response.map(role => ({
      ...role,
      description: role.description || 'No Description'
    }));
    setRoles(rolesWithDescriptions || []);
    setFilteredRoles(rolesWithDescriptions || []);
    setAvailableRoles(response.map(role => role.value) || []);
  } catch (err) {
    console.error('Error fetching roles:', err);
    setError('Failed to load roles. Please try again later.');
  } finally {
    setIsLoading(false);
  }
};

useEffect(() => {
  fetchRoles();
}, []);

useEffect(() => {
  console.log('Updated Available Roles:', availableRoles);
}, [availableRoles]);

  useEffect(() => {
    const filtered = roles.filter(role =>
      role.value.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredRoles(filtered);
  }, [searchQuery, roles]);

  useEffect(() => {
  if (showUserDetails) {
    const fetchUserDetails = async () => {
      try {
        setIsLoading(true);
        const response = await apiService.fetchData('user/roles');
        console.log('User roles response:', response);
        setUserDetails(response.data || []);
      } catch (err) {
        console.error('Error fetching user details:', err);
        setError('Failed to load user details. Please try again later.');
      } finally {
        setIsLoading(false);
      }
    };
    fetchUserDetails();
  }
}, [showUserDetails]);

useEffect(() => {
  if (isAssignModalOpen) {
    const fetchAllUsers = async () => {
      try {
        const response = await apiService.fetchData('user/all');
        console.log('All users response:', response);
        setAllUsers(response.data || []);
      } catch (err) {
        console.error('Error fetching users:', err);
        setSnackbarMessage('Failed to load users');
        setIsSuccess(false);
        setSnackbarOpen(true);
      }
    };
    fetchAllUsers();
  }
}, [isAssignModalOpen]);

useEffect(() => {
  const searchTerm = userDetailsSearch.toLowerCase();
  const filtered = userDetails.filter(user =>
    (user.email || user.user_email || '').toLowerCase().includes(searchTerm) ||
    (user.name || user.user_name || '').toLowerCase().includes(searchTerm) ||
    (user.role_name || '').toLowerCase().includes(searchTerm)  // Use role_name for consistency
  );
  setFilteredUserDetails(filtered);
}, [userDetails, userDetailsSearch]);

useEffect(() => {
  if (searchParams.get('view') === 'user-details') {
    setShowUserDetails(true);
  }
}, [searchParams]);

const handleAddRole = async () => {
  if (!newRoleName.trim()) {
    setSnackbarMessage('Role name is required');
    setIsSuccess(false);
    setSnackbarOpen(true);
    return;
  }

  try {
    setIsLoading(true);
    const newRole = {
      value: newRoleName,
      description: newRoleDescription || 'No Description',
      created_by: sessionStorage.getItem('user_role') || 'admin'
    };
    const response = await apiService.postData('metadata/role', newRole);
    if (response.status === 'success') {
      await fetchRoles(); // Refetch roles
      setNewRoleName('');
      setNewRoleDescription('');
      setIsModalOpen(false);
      setSnackbarMessage('Role added successfully');
      setIsSuccess(true);
      setSnackbarOpen(true);
    } else {
      throw new Error(response.message || 'Failed to add role');
    }
  } catch (err) {
   console.error('Error adding role:', err);
  const errorMessage = err.response?.status === 409 
    ? 'Role name already exists' 
    : (err.response?.data?.message || err.message || 'Failed to add role. Please try again later.');
  setSnackbarMessage(errorMessage);
  setIsSuccess(false);
  setSnackbarOpen(true);
  } finally {
    setIsLoading(false);
  }
};
const handleDeleteRole = async (id) => {
  try {
    setIsLoading(true);
    const response = await apiService.deleteData(`metadata/role/${id}`);
    if (response.status === 'success') {
      await fetchRoles(); // Refetch roles
      setSnackbarMessage('Role deleted successfully');
      setIsSuccess(true);
      setSnackbarOpen(true);
    } else {
      throw new Error(response.message || 'Failed to delete role');
    }
  } catch (err) {
    console.error('Error deleting role:', err);
    setSnackbarMessage(err.message || 'Failed to delete role. Please try again later.');
    setIsSuccess(false);
    setSnackbarOpen(true);
  } finally {
    setIsLoading(false);
    setIsDeleteModalOpen(false);
    setDeleteRoleId(null);
  }
};

const sendEmail = async (to, subject, html) => {
  const emailServiceUrl =
    "https://crticketingsystem-backend-dev.icyfield-14eece6f.eastus.azurecontainerapps.io/api/send_email";

  const response = await fetch(emailServiceUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ to, subject, html }),
  });

  if (!response.ok) throw new Error(`Failed to send email to ${to}`);
  return response.json();
};

// const handleAssignRole = async () => {
//   if (!selectedUserId || !selectedRole) {
//     setSnackbarMessage('User Email and Role are required');
//     setIsSuccess(false);
//     setSnackbarOpen(true);
//     return;
//   }

//   try {
//     setIsLoading(true);
//     const payload = { 
//       user_id: parseInt(selectedUserId), 
//       role_id: parseInt(selectedRole) 
//     };
//     console.log('Assign role payload:', payload);
//     const response = await apiService.postData('user/assign-role', payload);
//     console.log('Assign role response:', response);
    
//     if (response.status === 'success') {
//       const selectedUser = allUsers.find(u => u.user_id === parseInt(selectedUserId));
//   const selectedRoleData = roles.find(r => r.id === parseInt(selectedRole));
//   const userName = selectedUser ? (selectedUser.user_name || selectedUser.email || selectedUser.user_email) : 'User';
//   const roleName = selectedRoleData ? selectedRoleData.value : 'role';

  
//   const loggedInEmail = sessionStorage.getItem("user_emailId");
//   if (loggedInEmail && loggedInEmail === (selectedUser.email || selectedUser.user_email)) {
//     sessionStorage.setItem("user_role", roleName.replace(/\s+/g, ''));
//     window.location.href = "/";
//   }

//   setSnackbarMessage(`${userName} has been assigned to the ${roleName} role`);
//   setIsSuccess(true);
//   setSnackbarOpen(true);
//   setSelectedUserId('');
//   setSelectedRole('');
//   setIsAssignModalOpen(false);
//     } else {
//       throw new Error(response.message || 'Failed to assign role');
//     }
//   } catch (err) {
//     console.error('Error assigning role:', err);
//     setSnackbarMessage(err.message || 'Failed to assign role');
//     setIsSuccess(false);
//     setSnackbarOpen(true);
//   } finally {
//     setIsLoading(false);
//   }
// };
const handleAssignRole = async () => {
  if (!selectedUserId || !selectedRole) {
    setSnackbarMessage('User Email and Role are required');
    setIsSuccess(false);
    setSnackbarOpen(true);
    return;
  }

  try {
    setIsLoading(true);
    const payload = { 
      user_id: parseInt(selectedUserId), 
      role_id: parseInt(selectedRole) 
    };
    console.log('Assign role payload:', payload);
    const response = await apiService.postData('user/assign-role', payload);
    console.log('Assign role response:', response);
    
    if (response.status === 'success') {
      const selectedUser = allUsers.find(u => u.user_id === parseInt(selectedUserId));
      const selectedRoleData = roles.find(r => r.id === parseInt(selectedRole));
      const userName = selectedUser ? (selectedUser.user_name || selectedUser.email || selectedUser.user_email) : 'User';
      const roleName = selectedRoleData ? selectedRoleData.value : 'role';
      const userEmail = selectedUser ? (selectedUser.email || selectedUser.user_email) : '';

      // Send email to assigned user
      if (userEmail) {
        console.log(`Sending role assignment email to: ${userEmail} (${userName}) for role: ${roleName}`);

        const loginUrl = window.location.origin + "/login";
        const html = UserRoleAssignedTemplate({
          userName,
          roleName,
          loginUrl,
        });

        const subject = `You have been assigned the role: ${roleName}`;

        try {
          await sendEmail(userEmail, subject, html);
          console.log(`Email sent successfully to ${userEmail}`);
        } catch (emailError) {
          console.error("Failed to send role assignment email:", emailError);
          setSnackbarMessage(`Role assigned to ${userName}, but email failed.`);
          setIsSuccess(false);
          setSnackbarOpen(true);
          setIsLoading(false);
          return;
        }
      }

      setSnackbarMessage(`${userName} has been assigned to the ${roleName} role and notified via email.`);
      setIsSuccess(true);
      setSnackbarOpen(true);
      setSelectedUserId('');
      setSelectedRole('');
      setIsAssignModalOpen(false);
    } else {
      throw new Error(response.message || 'Failed to assign role');
    }
  } catch (err) {
    console.error('Error assigning role:', err);
    setSnackbarMessage(err.message || 'Failed to assign role');
    setIsSuccess(false);
    setSnackbarOpen(true);
  } finally {
    setIsLoading(false);
  }
};

const handleSaveEdit = async (id) => {
  if (!editRoleName.trim()) {
    setSnackbarMessage('Role name is required');
    setIsSuccess(false);
    setSnackbarOpen(true);
    return;
  }
  try {
    setIsLoading(true);
    const originalRole = roles.find(role => role.id === id);
    const updatedValues = {};
    if (originalRole.value !== editRoleName) {
      updatedValues.RoleName = editRoleName;
    }
    if (originalRole.description !== editRoleDescription) {
      updatedValues.description = editRoleDescription;
    }
    const payload = {
      values: updatedValues,
      updated_by: sessionStorage.getItem('user_id')
    };
    if (Object.keys(updatedValues).length === 0) {
      setSnackbarMessage('No changes detected');
      setIsSuccess(false);
      setSnackbarOpen(true);
      return;
    }
    const response = await apiService.putData(`metadata/role/${id}`, payload);
    if (response.status === 'success') {
      await fetchRoles(); // Refetch roles
      setSnackbarMessage('Role updated successfully');
      setIsSuccess(true);
      setSnackbarOpen(true);
    } else {
      throw new Error(response.message || 'Failed to update role');
    }
  } catch (err) {
    console.error('Error updating role:', err);
    setSnackbarMessage(err.message || 'Failed to update role. Please try again later.');
    setIsSuccess(false);
    setSnackbarOpen(true);
  } finally {
    setIsLoading(false);
    setIsEditModalOpen(false);
    setEditingId(null);
    setEditRoleName('');
    setEditRoleDescription('');
  }
};

// New: Delete User Role Assignment
const handleDeleteUserRole = async (id) => {
  try {
    setIsLoading(true);
    const payload = {
      user_id: deleteRoleId,
      role_id: 1
    };
    const response = await apiService.deleteData('user/assign-role', payload);
    if (response.status === 'success') {
      const updated = userDetails.filter(user => user.user_id !== deleteRoleId);
      setUserDetails(updated);
      setFilteredUserDetails(updated);
      setSnackbarMessage('User role deleted successfully');
      setIsSuccess(true);
      setSnackbarOpen(true);
    } else {
      throw new Error(response.message || 'Failed to delete user role');
    }
  } catch (err) {
    console.error('Error deleting user role:', err);
    setSnackbarMessage(err.message || 'Failed to delete user role. Please try again later.');
    setIsSuccess(false);
    setSnackbarOpen(true);
  } finally {
    setIsLoading(false);
    setIsDeleteModalOpen(false);
    setDeleteRoleId(null);
  }
};

// Helper to close edit modal
const closeEditUserModal = () => {
  setIsEditModalOpen(false);
  setEditingId(null);
  setEditRoleName('');
  setEditRoleDescription('');
};

 const renderMainContent = () => {
  if (isLoading) {
    return <Loader isLoading={isLoading} message="Loading Roles..." color="#ff6b35" />;
  }
  if (error) {
    return <div className="error">{error}</div>;
  }
  return showUserDetails ? (
    <>
      <div className="search-container" style={{ marginRight: '10px' }}>
        <input
          type="text"
          placeholder="Search by email, name, or role..."
          value={userDetailsSearch}
          onChange={(e) => {
            setUserDetailsSearch(e.target.value);
            setCurrentPage(1);
          }}
          className="search-input"
          style={{ width: '300px' }}
        />
        <svg className="role-search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      </div>
      <table className="roles-table">
        <thead>
          <tr>
            <th>User Email</th>
            <th>Role Name</th>
            <th>User Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredUserDetails.length > 0 ? (
            filteredUserDetails
              .slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
              .map((user) => (
                <tr key={user.user_id}>
                  <td>{user.user_email}</td>
                  <td>{user.role_name || 'N/A'}</td>
                  <td>{user.user_name || 'N/A'}</td>
                  <td>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                      }}
                    >
                      <Delete
                        style={{
                          cursor: 'pointer',
                          width: '20px',
                          height: '20px',
                          color: '#ff6b35',
                        }}
                        titleAccess="Delete User Role"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setDeleteRoleId(user.user_id);
                          setIsDeleteModalOpen(true);
                        }}
                      />
                    </div>
                  </td>
                </tr>
              ))
          ) : (
            <tr>
              <td colSpan="4">No records found.</td>
            </tr>
          )}
        </tbody>
      </table>
      {filteredUserDetails.length > 0 && (
        <div className="pagination">
          <button
            className="pagination-button"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => prev - 1)}
            title="Previous Page"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
          <span className="pagination-page">
            {currentPage} / {Math.ceil(filteredUserDetails.length / rowsPerPage) || 1}
          </span>
          <button
            className="pagination-button"
            disabled={currentPage === Math.ceil(filteredUserDetails.length / rowsPerPage)}
            onClick={() => setCurrentPage((prev) => prev + 1)}
            title="Next Page"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
            className="pagination-select"
          >
            {[5, 10, 20, 50].map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      )}
    </>
  ) : (
    <>
      <div className="search-container">
        <input
          type="text"
          placeholder="Search roles..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="search-input"
        />
        <svg
          className="role-search-icon"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#666"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      </div>
      <table className="roles-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Role Name</th>
            <th>Role Description</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredRoles.length > 0 ? (
            filteredRoles.map((role,index) => (
              <tr key={role.id}>
                <td>{index + 1}</td>
                <td>{role.value}</td>
                <td>{role.description || 'No description available'}</td>
                <td>
                  <svg
                    className="edit-icon"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#ff6b35"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ cursor: 'pointer', marginRight: '10px', display: 'inline-block', verticalAlign: 'middle' }}
                    onClick={() => {
                      setIsEditModalOpen(true);
                      setEditingId(role.id);
                      setEditRoleName(role.value);
                      setEditRoleDescription(role.description || '');
                    }}
                  >
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                  </svg>
                  <Delete
                    style={{
                      cursor: role.is_deleted ? 'not-allowed' : 'pointer',
                      width: '20px',
                      height: '20px',
                      color: '#ff6b35',
                      fill: role.is_deleted ? '#ff6b35' : '',
                      display: 'inline-block',
                      verticalAlign: 'middle',
                    }}
                    titleAccess={role.is_deleted ? 'Already Deleted' : 'Delete Role'}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      console.log(`Delete icon clicked for role ID: ${role.id}`);
                      if (!role.is_deleted) {
                        setDeleteRoleId(role.id);
                        setIsDeleteModalOpen(true);
                      }
                    }}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4">No roles found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};
return (
  <div className="roles-page-container">
    <Sidebar />
    <div className="roles-page-content">
      <Breadcrumbs customLabel={showUserDetails ? 'User Details' : 'Roles'} />
      <div className="roles-header">
        <h2 style={{ color: '#ff6b35', fontSize: '24px' }}>{showUserDetails ? 'User Details' : 'Roles'}</h2>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <button className="add-role-button" onClick={() => setIsModalOpen(true)}>
            Add Role
          </button>
          <button className="assign-role-button" onClick={() => setIsAssignModalOpen(true)}>
            Assign Role
          </button>
          <button
            className="add-role-button"
            onClick={() => setShowUserDetails(!showUserDetails)}
          >
            {showUserDetails ? 'Back to Roles' : 'User Details'}
          </button>
        </div>
      </div>
      {renderMainContent()}
      {isModalOpen && (
        <div className="role-modal-overlay">
          <div className="role-modal-content">
            <h3>Add Role</h3>
            <div className="role-modal-form">
              <label htmlFor="role-name">Role Name</label>
              <input
                id="role-name"
                type="text"
                value={newRoleName}
                onChange={(e) => setNewRoleName(e.target.value)}
                placeholder="Enter role name"
                className="modal-input"
              />
              <label htmlFor="role-description">Description</label>
              <input
                id="role-description"
                type="text"
                value={newRoleDescription}
                onChange={(e) => setNewRoleDescription(e.target.value)}
                placeholder="Enter description"
                className="modal-input"
              />
            </div>
            <div className="role-modal-buttons">
              <button
                className="role-modal-button role-save-button"
                onClick={handleAddRole}
              >
                Save
              </button>
              <button
                className="role-modal-button role-cancel-button"
                onClick={() => {
                  setNewRoleName('');
                  setNewRoleDescription('');
                  setIsModalOpen(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {isAssignModalOpen && (
        <div className="role-modal-overlay">
          <div className="role-modal-content">
            <h3>Assign Role</h3>
            <div className="role-modal-form">
              <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                <div style={{ flex: 1 }}>
                  <label htmlFor="user-email">User Email</label>
                  <CustomSelect
                    options={allUsers.map(user => ({
                      label: user.email || user.user_email,
                      value: user.user_id
                    }))}
                    value={selectedUserId}
                    onChange={(val) => setSelectedUserId(val)}
                    placeholder="Select user email"
                    className="role-modal-input-custom"
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label htmlFor="role-name-select">Role Name</label>
                  <CustomSelect
                    options={roles.map(role => ({
                      label: role.value,
                      value: role.id
                    }))}
                    value={selectedRole}
                    onChange={(val) => setSelectedRole(val)}
                    placeholder="Select a role"
                    className="role-modal-input-custom"
                  />
                </div>
              </div>
            </div>
            <div className="modal-buttons">
              <button
                className="modal-button save-button"
                onClick={handleAssignRole}
              >
                Save
              </button>
              <button
                className="modal-button cancel-button"
                onClick={() => {
                  setSelectedUserId('');
                  setSelectedRole('');
                  setIsAssignModalOpen(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {isEditModalOpen && (
        <div className="modal-overlay">
          <div className="contract_types-modal-content">
            <div className="contract_types-modal-header" style={{ backgroundColor: '#ff6b35', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '50px', paddingLeft: '10px', borderTopLeftRadius: '6px', borderTopRightRadius: '6px' }}>
              <h3 style={{ margin: 0 }}>Update Role</h3>
            </div>
            <div className="contract_types-modal-form">
              <label htmlFor="edit-role-name" className="contract_type-label">Role Name</label>
              <input
                id="edit-role-name"
                type="text"
                value={editRoleName}
                onChange={(e) => setEditRoleName(e.target.value)}
                placeholder="Enter role name"
                className="modal-input"
              />
              <label htmlFor="edit-role-description" className="contract_type-label">Description</label>
              <input
                id="edit-role-description"
                type="text"
                value={editRoleDescription}
                onChange={(e) => setEditRoleDescription(e.target.value)}
                placeholder="Enter description"
                className="modal-input"
              />
            </div>
            <div className="modal-buttons">
              <button
                className="modal-button save-button"
                onClick={() => handleSaveEdit(editingId)}
              >
                Save
              </button>
              <button
                className="modal-button cancel-button"
                onClick={() => {
                  setIsEditModalOpen(false);
                  setEditingId(null);
                  setEditRoleName('');
                  setEditRoleDescription('');
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {isDeleteModalOpen && (
        <div className="role-modal-overlay">
          <div className="role-modal-content">
            <h3>Confirm Delete</h3>
            <p>Do you want to delete this {showUserDetails ? 'User' : 'role'}?</p>
            <div className="role-modal-buttons">
              <button
                className="role-modal-button role-save-button"
                onClick={showUserDetails ? () => handleDeleteUserRole(deleteRoleId) : () => handleDeleteRole(deleteRoleId)}
              >
                Delete
              </button>
              <button
                className="role-modal-button role-cancel-button"
                onClick={() => {
                  setIsDeleteModalOpen(false);
                  setDeleteRoleId(null);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        sx={{
          '& .MuiSnackbarContent-root': {
            backgroundColor: isSuccess ? '#4caf50' : '#f44336',
          },
          zIndex: 1400,
        }}
      />
    </div>
  </div>
);
};

export default Roles;